export default __webpack_public_path__ + "static/media/wordcloud.7b5c70fa.png";